// @flow

import React from 'react'
import {Language} from '@/types'
import GoAlert from 'react-icons/lib/go/alert'
import FaInfoCircle from 'react-icons/lib/fa/info-circle'
import './info-alert.css'

type Props = {
  alertText: string,
  l: Language,
  isWarn: bool,
}

const InfoAlert = (props: Props) => (
  < div className={`info-alert-ctr ${props.isWarn ? 'info-alert-red' : 'info-alert-blue'}`} >
    <a data-text={props.l(props.alertText)}>{props.isWarn ? <GoAlert /> : <FaInfoCircle />}</a>
  </div>
)

export default InfoAlert



// WEBPACK FOOTER //
// ./src/elements/info-alert.js